interface SignatureArtifactProps {
  image?: string;
  signedAt?: string;
  signerName: string;
  subtitle?: string;
  showHeader?: boolean;
}

function formatSignedDate(value?: string) {
  if (!value) {
    return "Captured on submit";
  }

  const parsed = new Date(value);

  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });
}

export function SignatureArtifact({
  image,
  signedAt,
  signerName,
  subtitle = "Signature"
}: SignatureArtifactProps) {
  const displayName = signerName.trim() || "Pending signer";

  return (
    <div className="overflow-hidden rounded-[28px] border border-line/80 bg-[linear-gradient(180deg,rgba(255,255,255,1)_0%,rgba(248,250,252,1)_100%)] shadow-[0_14px_36px_rgba(15,23,42,0.06)]">
      <div className="flex flex-col gap-3 border-b border-line/70 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="inline-flex items-center gap-2 rounded-full bg-cloud px-3 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-royal">
          {subtitle}
        </div>
        <p className="text-xs font-medium text-slate">{formatSignedDate(signedAt)}</p>
      </div>

      <div className="px-5 py-5">
        <div className="relative overflow-hidden rounded-[26px] border border-line/70 bg-white px-4 py-6 sm:px-6 sm:py-7">
          <div className="pointer-events-none absolute inset-x-8 bottom-16 h-px bg-gradient-to-r from-transparent via-navy/30 to-transparent" />
          <div className="pointer-events-none absolute inset-x-0 bottom-11 flex justify-center">
          </div>

          <div className="relative flex min-h-[180px] items-center justify-center sm:min-h-[220px]">
            {image ? (
              <img
                alt={`${displayName} signature`}
                className="max-h-[170px] w-auto max-w-full object-contain sm:max-h-[190px]"
                src={image}
              />
            ) : (
              <span
                className="text-center text-[clamp(2.8rem,3.8vw,5rem)] text-[#13244d]/80"
                style={{ fontFamily: "\"Great Vibes\", cursive", lineHeight: 1.05 }}
              >
                {displayName}
              </span>
            )}
          </div>
        </div>
      </div>


    </div>
  );
}

// function MetadataCell({ label, value }: { label: string; value: string }) {
//   return (
//     <div>
//       <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-slate/65">{label}</p>
//       <p className="mt-2 text-sm font-medium text-ink">{value}</p>
//     </div>
//   );
// }
